import type { ResourceCategory } from '@/types/api';
import { BASE_TONE_CLASSES, type BaseToneClasses, type ToneKey } from '@/lib/tone-tokens';
import type { TKey } from '@/i18n/msg';

// The relationship tones, labels and picker options (#2109 R3-B4, #2423) went
// with the People address book in wave w1023c (Victor, 2026-10-23).

/**
 * The family-facing resource category headings (`FamilyResourceList`). The
 * staff editor keeps `CATEGORY_LABELS` (`lib/resource-display.ts`) until R4.
 */
export const RESOURCE_CATEGORY_LABEL_KEY: Readonly<Record<ResourceCategory, TKey>> = {
  financial: 'circle:resources.category.financial',
  housing: 'circle:resources.category.housing',
  medical: 'circle:resources.category.medical',
  counseling: 'circle:resources.category.counseling',
  legal: 'circle:resources.category.legal',
  community: 'circle:resources.category.community',
  other: 'circle:resources.category.other',
} as const;

/**
 * How soon the family's TRF contact answers, in business days. The TRF
 * contact card that opens the Resources page promises it in so many words.
 *
 * Victor's ruling, 2026-10-23 (wave w1023c): "The TRF contact card promises a
 * reply within 3 business days." Change the number here and nowhere else.
 */
export const TRF_CONTACT_REPLY_BUSINESS_DAYS = 3;

export function initials(name?: string | null): string {
  const source = name?.trim() || '?';
  const parts = source.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts.at(-1)![0]}`.toUpperCase();
}

/** The page's tone rows: the shared base (#747). The TRF contact's avatar
 *  takes the indigo identity mark. */
export const TONE_CLASSES: Record<ToneKey, BaseToneClasses> = BASE_TONE_CLASSES;
